
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lien-he-tnh",
      function () {
        return require("private-next-pages/lien-he-tnh/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lien-he-tnh"])
      });
    }
  